import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { FormFieldRenderer } from '../../../field-renderer';
import messages from '../../messages';

const AgeCertificationField = (props) => {
  const { formatMessage } = useIntl();
  const {
    value,
    handleChange,
    name = 'age_certification',
  } = props;

  const handleOnChange = (e) => {
    const isChecked = e.target.checked;
    handleChange({ target: { name, value: isChecked, type: 'checkbox', checked: isChecked } });
  };

  return (
    <FormFieldRenderer
      className="form-field--checkbox"
      fieldData={{
        type: 'checkbox',
        name,
        label: formatMessage(messages['registration.age_certification.label']),
      }}
      value={!!value}
      onChangeHandler={handleOnChange}
    />
  );
};

AgeCertificationField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  handleChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  name: PropTypes.string,
};

AgeCertificationField.defaultProps = {
  value: false,
};

export default AgeCertificationField;
